import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {

  constructor() {
    super();
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.queryParams.nId) {
        return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}